import React, { Component } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { connect } from "react-redux"
import { compose } from "redux"
import { translate } from "react-i18next"
import * as customReportApiActions from "../../../state/actions/customReportApiActions"
import { Button } from "../../themed-html-components"
import spinnerGif from "../../../images/gifs/reload-spinner-for-button.gif"

const ButtonContainer = styled.div`
  margin-bottom: 2em;
`

class ReportRequestRefreshButton extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    refreshReports: PropTypes.func.isRequired,
  }

  componentDidMount = () => {
    // Refresh the list on load
    this.props.refreshReports()

    // Then refresh it every 10 seconds thereafter
    const refreshSeconds = 10
    this.intervalId = setInterval(() => this.props.refreshReports(true), 1000 * refreshSeconds)
  }

  componentWillUnmount() {
    clearInterval(this.intervalId)
  }

  render() {
    const { t, refreshReports, reportLoadingInProgress } = this.props
    return (
      <ButtonContainer className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="float-right">
              <Button
                onClick={() => refreshReports(false)}
                inverted
                disabled={reportLoadingInProgress}
              >
                {t("CustomReport.RequestedReport.RefreshList")}
                {reportLoadingInProgress && (
                  <img
                    src={spinnerGif}
                    alt="spinner"
                    style={{ width: "14px", height: "14px", marginLeft: "5px" }}
                  />
                )}
              </Button>
            </div>
          </div>
        </div>
      </ButtonContainer>
    )
  }
}

function mapStateToProps(state) {
  return {
    reportLoadingInProgress: state.customReport.reportLoadingInProgress,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    refreshReports: (autoRefresh) => {
      dispatch(customReportApiActions.refreshSubmittedReportList(autoRefresh))
    },
  }
}

export default compose(translate(), connect(mapStateToProps, mapDispatchToProps))(ReportRequestRefreshButton)



// WEBPACK FOOTER //
// ./src/components/custom-report/ReportRequestsTab/ReportRequestRefreshButton.jsx